// Spiegel von backend/routes/offers_sort.py:
// Wärmepumpe → Speicher → Material (Hydraulik, Elektrik) → Montage → Beratung → Sonstiges.
const RANK = { hardware: 1, wp_package: 1, bundle: 1, speicher: 2, hydraulisch: 3, elektrisch: 4, montage: 5, beratung: 6, addon: 7 };
const SPEICHER = /speicher|puffer|bwsp|boiler/;
const KEYWORDS = [
  ["beratung", /beratung|planung|heizlast|anmeldung|netzbetreiber|bza|bnd|energieberat|förderantrag|abgleich/],
  ["elektrisch", /elektr|z[äa]hler|kabel|leitungsschutz|fi-schutz/],
  ["montage", /montage|inbetriebnahme|installation|demontage|einbau/],
  ["hardware", /w[äa]rmepumpe|\bwp\b|monoblock|monobloc|split|therma|außeneinheit|inneneinheit/],
  ["hydraulisch", /hydraul|rohr|pumpengruppe|ventil|weiche|leitung|kondensat|sockel|konsole|material/],
];

export function itemGroup(it = {}) {
  const cat = String(it.category || "").toLowerCase();
  if (cat === "hardware" || cat === "wp_package" || cat === "bundle") return cat;
  const head = String(it.title || it.name || it.model || it.description || "").toLowerCase().split("(")[0];
  if (SPEICHER.test(head) && !head.includes("material")) return "speicher";
  if (RANK[cat]) return cat;
  const txt = ["title", "name", "brand", "model", "description"].map((k) => it[k] || "").join(" ").toLowerCase();
  for (const source of [head, txt]) {
    const hit = KEYWORDS.find(([, re]) => re.test(source));
    if (hit) return hit[0];
  }
  return "addon";
}

export const sortOfferItems = (items = []) =>
  items.map((it, i) => [it, i]).sort((a, b) => (RANK[itemGroup(a[0])] - RANK[itemGroup(b[0])]) || a[1] - b[1]).map(([it]) => it);
